exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topAD[data-v-5fa2d77a]{height:24px;line-height:24px;padding:7px;overflow:hidden;background:#1c2744;color:#ed2203}.topAD img[data-v-5fa2d77a]{height:24px}.topAD a[data-v-5fa2d77a]{display:block;border:1px solid #eb2203;border-radius:12px;height:22px;line-height:22px;font-size:12px;padding:0 12px;margin-right:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-5fa2d77a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Modular/topAd.vue
// module id = 332
// module chunks = 0